import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pm",
  "use": "icon-pm-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" id=\"icon-pm\"><path d=\"M11.228 11.049A5.604 5.604 0 0 1 8.303.704 6.4 6.4 0 0 0 6.72.5a6.5 6.5 0 1 0 0 13 6.42 6.42 0 0 0 5.06-2.48 5 5 0 0 1-.552.029\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol